module.exports = __webpack_public_path__ + "img/HINDU DIWALI PURPLE.17cb8e9.svg";